import general from './general.js'

var calculateOffsets = {
	init: function (options) {
		this.callback = options.callback
		this.addConditionals = options.addConditionals

		this.treeDepth = []
		this.childrenTreeArr = []
		this.offset = 0
		// find new order by updating the offsets for each ID
		const mainDraggableContainer = options.container || document.querySelector('.main-draggable-container')
		var children = general.childrenMatches(mainDraggableContainer, '.draggable-item')

		this.treeDepth.push({
			'children': children,
			'amountOfChildren': children.length,
			'currentChildIndex': 0
		})

		this.mapChildrenTree()
	},

	mapChildrenTree: function () {
		var lastDepth = this.treeDepth[this.treeDepth.length - 1]
		var currentChild = lastDepth.children[lastDepth.currentChildIndex]

		// find out where we need to go next
		if (!currentChild) {
			// there are no more children so we can go up in depth
			// if we can't go up in depth anymore then the whole tree is complete!
			var prevDepth = this.treeDepth[this.treeDepth.length - 2]
			if (!prevDepth) {
				this.callback(this.childrenTreeArr)
			} else {
				// increment offset to prepare for the next offset
				this.offset++

				// edit offset right of parent element
				var newLastDepth = this.treeDepth[this.treeDepth.length - 1]
				if (newLastDepth && newLastDepth.id) {
					for (var i = this.childrenTreeArr.length - 1; i >= 0; i--) {
						if (this.childrenTreeArr[i].id == newLastDepth.id) {
							this.childrenTreeArr[i]['offset_right'] = this.offset
							if (this.addConditionals === true) this.childrenTreeArr[i]['isConditionalParent'] = true
						}

						if (i === 0) this.goUpInDepth()
					}
				} else {
					this.goUpInDepth()
				}
			}
		} else {
			this.offset++

			// find draggable container
			const draggableContainer = currentChild.querySelector('.draggable-container')
			// find children
			var newChildren = general.childrenMatches(draggableContainer, '.draggable-item')

			// prepare offset values
			var id = currentChild.getAttribute('data-id')
			if (!id) id = currentChild.getAttribute('data-uuid')
			var obj = {
				'id': id,
				'offset_left': this.offset,
				'offset_right': this.offset + 1
			}

			// increment current child index so we know where to continue next iteration
			lastDepth.currentChildIndex++

			// add conditionals to obj if the depth is deeper than 1 level
			if (this.treeDepth.length > 1 && this.addConditionals === true) {
				obj['conditional'] = ''
				obj['conditionalParent'] = lastDepth.id
			}

			// add the object to the tree
			this.childrenTreeArr.push(obj)

			if (newChildren.length > 0) {
				// add depth
				this.treeDepth.push({
					'id': obj.id,
					'children': newChildren,
					'amountOfChildren': newChildren.length,
					'currentChildIndex': 0
				})
			} else {
				// increment offset to prepare for the next offset
				this.offset++
			}

			this.mapChildrenTree()
		}
	},

	goUpInDepth: function () {
		// remove the depth we just finished and complete the previous one
		this.treeDepth.pop()
		this.mapChildrenTree()
	}
}

export default calculateOffsets
